import { ManageFundsRequestsPage } from 'features/funds-request';

export const AdminFundsRequestsPage: React.FC = () => (
  <ManageFundsRequestsPage />
);
